import React from "react";
import { Card, Badge, Button } from "react-bootstrap";

/**
 * Displays a single event access QR code with status and expiry.
 * @param {Object} props
 * @param {string} [props.qrCodeUrl] - URL to QR image
 * @param {Object} [props.event] - { title, ... }
 * @param {string} [props.expiresAt] - ISO date string
 * @param {boolean} [props.isUsed]
 */
export default function QRCodeCard({ qrCodeUrl, event, expiresAt, isUsed }) {
  const now = new Date();
  const expired = expiresAt ? new Date(expiresAt) < now : false;

  let statusVariant = "success";
  let statusText = "Valid";
  if (isUsed) {
    statusVariant = "secondary";
    statusText = "ACCESS USED";
  } else if (expired) {
    statusVariant = "warning";
    statusText = "Expired";
  }

  const expiryLabel = expiresAt
    ? new Date(expiresAt).toLocaleString(undefined, {
        dateStyle: "short",
        timeStyle: "short",
      })
    : "—";

  return (
    <Card className="shadow-sm">
      <Card.Body className="text-center">
        {qrCodeUrl ? (
          <div className="mb-3">
            <img
              src={qrCodeUrl}
              alt="Event access QR code"
              style={{ maxWidth: 256, height: "auto", imageRendering: "pixelated" }}
            />
            {!isUsed && (
              <div className="mt-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  as="a"
                  href={qrCodeUrl}
                  download="event-access-qr.png"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download QR
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className="mb-3 py-5 bg-light rounded">
            <span className="text-muted">No QR code available</span>
          </div>
        )}
        <Card.Title className="h6 mb-2">
          {event?.title || "Event"}
        </Card.Title>
        <Badge bg={statusVariant} className="mb-2">
          {statusText}
        </Badge>
        {!isUsed && expiresAt && (
          <p className="small text-muted mb-0">
            Expires: {expiryLabel}
          </p>
        )}
      </Card.Body>
    </Card>
  );
}
